import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../../types'
import { TopicTeaserBoxItemData } from './topic-teaser-box-item/topic-teaser-box-item.component.converter'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TopicTeaserBoxConverter extends CmsConverterService<TopicTeaserBoxData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      items: formData.st_teaser_boxes ?? defaultFSCatalog,
      zoomOut: formData.st_zoom_out?.value || false
    }
  }
}

export const TOPIC_TEASER_BOX_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TopicTeaserBoxData>>('TopicTeaserBoxConverter')

export interface TopicTeaserBoxData extends ConvertedComponentData {
  items: FsCatalog<TopicTeaserBoxItemData>;
  zoomOut: boolean;
}

